import analytics from 'lib/analytics/segment/load'
import {
	isUserProfileInitialized,
	useUserProfileContext
} from 'lib/contexts/userProfile.context'
import ChatProvider from 'lib/providers/chat.provider'
import CurrencyProvider from 'lib/providers/currency.provider'
import { FeatureProvider } from 'lib/providers/feature.provider'
import type { ReactElement } from 'react'

import { useEffect } from 'react'
import posthog from 'posthog-js'
import { getUnixTime, parseISO } from 'date-fns'
import lazyLoad from 'components/lazyComponent'
import SelectRoleView from 'pages/landing'
import PageLoader from 'components/pageLoader'

const Layout = lazyLoad(async () => import('components/layout'))

const App = (): ReactElement => {
	const { userProfile } = useUserProfileContext()

	useEffect(() => {
		if (userProfile) {
			const r = { data: userProfile }
			analytics.identify(r.data.id ?? '', {
				name: `${r.data.firstName} ${r.data.lastName}`,
				email: r.data.email,
				role: r.data.role
			})

			posthog.identify(r.data.id ?? '', {
				name: `${r.data.firstName} ${r.data.lastName}`,
				email: r.data.email,
				role: r.data.role,
				organizationId: r.data.organizationId,
				organizationName: r.data.organizationName,
				user_license: r.data.licenseInfo?.tier,
				user_license_type: r.data.licenseInfo?.type,
				user_license_expiration_at: r.data.licenseInfo?.expiryDate
					? getUnixTime(parseISO(r.data.licenseInfo.expiryDate))
					: null
			})

			globalThis.Intercom('boot', {
				app_id: 'tbzm7jeb',
				name: `${r.data.firstName} ${r.data.lastName}`,
				email: r.data.email,
				created_at: getUnixTime(parseISO(r.data.firstLogin ?? '')),
				user_hash: r.data.user_hash,
				company: r.data.organizationId
					? {
							id: r.data.organizationId,
							name: r.data.organizationName
						}
					: {},
				user_role: r.data.role,
				user_license: r.data.licenseInfo?.tier,
				user_license_type: r.data.licenseInfo?.type,
				user_license_expiration_at: r.data.licenseInfo?.expiryDate
					? getUnixTime(parseISO(r.data.licenseInfo.expiryDate))
					: null,
				associated_hotels:
					r.data.associatedVenues && r.data.associatedVenues.length > 0
						? r.data.associatedVenues.map(v => v.name).join(',')
						: null,
				default_property_id:
					r.data.associatedVenues && r.data.associatedVenues.length > 0
						? r.data.associatedVenues[0].id
						: null,
				custom_launcher_selector: '#custom-messenger-launcher'
			})
		}
	}, [userProfile])

	if (isUserProfileInitialized(userProfile)) {
		return (
			<FeatureProvider>
				<ChatProvider userProfileId={userProfile?.id ?? ''}>
					<CurrencyProvider>
						<Layout />
					</CurrencyProvider>
				</ChatProvider>
			</FeatureProvider>
		)
	}

	if (userProfile?.id) {
		return <SelectRoleView />
	}
	return <PageLoader />
}

export default App
